import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getHeaders } from "../../../helpers/helper";
import axiosInstance from "../../../shared/config/axiosInstance";

async function updateStores(data: any, getAccessTokenSilently: any): Promise<any> {
  const headers = await getHeaders(getAccessTokenSilently);
  
  const response = await axiosInstance.post('/admin/SetStores', data, {
    headers
  });
  
  return response.data;
}

export const useUpdateStores = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => updateStores(data, getAccessTokenSilently),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['user-stores'] });
    },
  });
};